.controlHeader {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.questionsContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.pageBodySection {
    background-color: var(--hps-white);
    border-radius: 1rem;
    padding: 20px;
    width: 100%;
}

.updatedQuestionsNotice {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
}